export const gasTypeNames = gasTypes => {
  let names = [];
  Object.keys(gasTypes).map(key => {
    if (gasTypes[key].enable) {
      names.push(key);
    }
    return '';
  });
  return names.map(x => {
    switch (x) {
      case 'gas92':
        return '92';
      case 'gas95':
        return '95';
      case 'gas98':
        return '98';
      case 'diesel':
        return '柴';
      default:
        return '';
    }
  });
};

export const currentPrice = currentPrice => {
  const currency = parseInt(currentPrice.price);
  switch (currentPrice.chargeMode) {
    case 'per_hour':
      return [`$${currency}/小時`];
    case 'progressive_rate':
      return [`$${currency}/首小時`];
    case 'per_use':
      return [`$${currency}/次`];
    case 'unknown':
      return ['費率未知'];
    default:
      return '';
  }
};

export const openingTime = openingTime => {
  if (openingTime.allDayOpen) {
    return '24H營業';
  } else {
    switch (openingTime.status) {
      case 'opening':
        return openingTime.period;
      default:
        return openingTime.detail[1];
    }
  }
};

export const cooperationStateValue = state => {
  switch (state) {
    case 'in_cooperated':
      return 0;
    case 'coming_soon':
      return 1;
    case 'not_in_cooperation':
      return 2;
    default:
      return '';
  }
};
